import isProduction from 'app/common/lib/isProduction'

// Статическое включение/выключение некоторого функционала

export const rootFeature = {
  warehouse: !isProduction(),
}
